<template>
  <v-card class="minContent">
    <!--<v-card-title v-if="showEditor === false">-->
      <v-card-title>
      <v-menu
        offset-y
        v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            :disabled="selected.length === 0"
            color="secondary"
          >
            <v-icon class="mr-2">mdi-menu-down</v-icon>
            {{ $t("base.actions") }}
          </v-btn>
        </template>

        <v-list>
          <!--
          <v-list-item
            @click="editRVModification()"
            :disabled="selected.length !== 1"
          >
            <v-icon class="mr-4">mdi-pencil</v-icon>
            {{ capitalizeString("base.edit")}}
          </v-list-item>
-->
          <v-list-item @click="deleteRVModifications()">
            <v-icon class="mr-4">mdi-delete-forever</v-icon>
            {{ capitalizeString("base.delete")}}
          </v-list-item>

          <v-list-item @click="exportData()">
            <v-icon class="mr-4">mdi-export</v-icon>
            {{ capitalizeString('base.export') }}
          </v-list-item>
        </v-list>
      </v-menu>
      <span
        v-if="hasUserRight('manageBaseData')"
        class="ml-8 body-1"
      >
        {{ selected.length + " " + $t('base.of') + " " + filteredList.length + " " + $t('base.selected') }}
      </span>
      <v-spacer />
      <QuickFilter
        v-if="hasInheritedRVModifications"
        class="mr-2"
        :label="$t('condAdmin.filter.inherited')"
        :count="inheritedCount"
        :active="showInherited === true"
        :deselectValue="null"
        @clicked="applyInheritedFilter"
      />
      <QuickFilter
        v-if="hasInheritedRVModifications"
        :label="$t('condAdmin.filter.own')"
        :count="filteredList.length - inheritedCount"
        :active="showInherited === false"
        :selectValue="false"
        :deselectValue="null"
        @clicked="applyInheritedFilter"
      />
      <v-btn
        v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true"
        @click="createRVModification()"
        color="secondary"
        class="mx-8"
        v-tooltip="$tooltip($t('condAdmin.tooltip.newRVModification'))"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        {{ $t("base.new") }}
      </v-btn>
      <v-icon
        @click="getRVModificationList()"
        color="secondary"
        class="mr-8"
        v-tooltip="$tooltip($t('condAdmin.tooltip.refresh'))"
      >mdi-reload</v-icon>

      <v-icon
        @click="saveUserTableSettings('rvModificationTable')"
        color="secondary"
        class="ml-8"
        v-tooltip="$tooltip($t('condAdmin.tooltip.save'))"
      >mdi-content-save-cog</v-icon>

      <JsonImporter
        v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true"
        class="ml-8"
        objectType="rvModifications"
        module="condAdmin"
        :preImportCheck="preImportCheckFunction"
        @import="importData"
      />
    </v-card-title>

    <v-card-text  class="pt-4">
      <v-row no-gutters>
        <v-col cols="12">
          <v-data-table
            ref="RVModificationDT"
            v-model="selected"
            :headers="listHeaders"
            :items="filteredList"
            :items-per-page="footerProps.itemsPerPage"
            :footer-props="footerProps"
            item-key="uid"
            show-select
            fixed-header
            :sort-by="listSortKey"
            @click:row="clickedRow"
            :loading="$store.state.condAdmin.rvModificationLoading"
            @update:items-per-page="getItemPerPage"
          >
            <template v-slot:body.prepend="{}">
              <tr>
                <td></td>
                <td
                  v-for="(h, index) in listHeaders"
                  :key="index"
                >
                  <SearchSelect
                    v-if="filter.hasOwnProperty(h.value) && filter[h.value].type === 'SelectBox'"
                    :value="filter[h.value].value"
                    @filter="applyFilters($event, h.value)"
                    :items="productSelectLists(filter[h.value].items)"
                    :item-text="filter[h.value].itemText"
                    :item-value="filter[h.value].itemValue"
                    :disabled="isDisabled(filter[h.value].value)"
                  />
                  <SearchField
                    v-if="filter.hasOwnProperty(h.value) && filter[h.value].type === 'SearchField'"
                    :value="filter[h.value].value"
                    @filter="applyFilters($event, h.value)"
                  />
                </td>
              </tr>
            </template>

            <template v-slot:header.data-table-select="{ on, props }">
              <v-simple-checkbox
                color="secondary"
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:[`header.menu`]="{}">
            </template>
            <template v-slot:item.state="{ item }">
              <v-chip :class="getStateClass(item)">
                {{ getStateText(item) }}
                <v-icon
                  class="ml-2"
                  v-if="item.inherited === true"
                >{{ getOrgSetting('createOwnData') === true ? 'mdi-link' : 'mdi-link-lock' }}</v-icon>
              </v-chip>
            </template>
            <template v-slot:[`item.subProductTypeUid`]="{ item }">
              {{ getSubProductTypesText([item.subProductTypeUid]) }}
            </template>

            <template v-slot:[`item.driveTypeUid`]="{ item }">
               <!-- {{ item.driveTypeUid.length === 0 ? '' : $store.state.condAdmin.driveTypeList.find(e=> e.driveTypeUid === item.driveTypeUid).name }} -->
                 {{ item.driveTypeUid.length === 0 ? '' : $store.state.condAdmin.driveTypeList.find(e=> e.uid === item.driveTypeUid).name }}
            </template>
            <template v-slot:[`item.rvModiValue`]="{ item }">
              {{formatValue($filters.formatNumber(item.rvModiValue, null, NULLVALUE),'%') }}
            </template>

            <template v-slot:item.productTypeUid="{item}">
              <div class="mt-6">
               {{ getProductTypesText([item.productTypeUid]) }}
              <v-edit-dialog
                :ref="'RVModificationDlg_' + item.rvmUid"
                :return-value.sync="item.productType"
                large
                cancel-text="Abbrechen"
                save-text="speichern"
                @save="save(item)"
                @cancel="cancelRVModification"
                :persistent=true
                class="grey lighten-5 noLines"
                >
                <template v-slot:input>
                  <div class="mt-4 text-h6">
                    {{ capitalizeString('condAdmin.rvModificationList.headline') }}
                  </div>
                  <v-row  no-gutters>
                    <v-select
                      :value="item.productTypeUid"
                      @change="setProductType(item, $event)"
                      :items="[{ uid: null, name: $t('base.all') }].concat($store.state.condAdmin.productTypeList)"
                      item-text="name"
                      item-value="uid"
                      hide-details
                      label="Objektart"
                      dense>
                    </v-select>
                    <v-select
                      :disabled="item.productTypeUid === null ||  item.productTypeUid.length == 0"
                      :value="item.subProductTypeUid"
                      @change="setSubProductType(item, $event)"
                      :items="[{ uid: null, name: $t('base.all') }].concat(getSubProductTypeList(item.productTypeUid))"
                      item-text="name"
                      item-value="uid"
                      item-key="uid"
                      :key="item.id"
                      hide-details
                      label="Objekunterart"
                      dense>
                    </v-select>
                    <v-select
                      v-model="item.brand"
                      :items="brandList"
                      item-text="text"
                      item-value="brand"
                      label="Marke"
                      hide-details dense>
                    </v-select>
                    <EditField
                      :disabled="item.brand === NULLVALUE || item.brand.length == 0"
                      @change="setProductName(item,$event)"
                      :value="item.productName"
                      :placeholder="$t('base.value')"
                      clearable
                      hideDetails
                      :dense="true"
                      :label="$t('condAdmin.product.productName')">
                    </EditField>
<!--
                    <v-select
                      v-model="item.productName"
                      :items="getModelList(item.brand)"
                      item-text="name"
                      item-value="uid"
                      label="Modell/Bezeichnung"
                      hide-details dense>
                    </v-select>-->
                    <v-select
                      :value="item.driveTypeUid"
                      :items="$store.state.condAdmin.driveTypeList"
                      @change="setDriveType(item,$event)"
                      item-text="name"
                      xxxitem-value="driveTypeUid"
                      item-value="uid"
                      label="Antriebsart"
                      hide-details
                      dense>
                    </v-select>
                    <EditField
                      @change="setRVModiValue(item,$event)"
                      :value="getRVModiValue(item)"
                      :placeholder="$t('base.value')"
                      clearable
                      hideDetails
                      suffix="%"
                      type="float"
                      :label="$t('condAdmin.rvModification.rvModiValue')"
                      :dense="true">
                    </EditField>
                  </v-row>
                </template>
              </v-edit-dialog>
              </div>
            </template>
<!--&& item.inherited !== true-->
            <template v-slot:item.menu="{ item }">
              <v-menu
                offset-y
                v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    :disabled=item.inherited
                    @click="editRVModification(item)">
                    <v-icon class="mr-4">mdi-pencil</v-icon>
                    {{ $t("base.edit")}}
                  </v-list-item>
                  <v-list-item
                  :disabled=item.inherited
                  @click="deleteRVModification(item)">
                    <v-icon class="mr-4">mdi-delete-forever</v-icon>
                    {{ $t("base.delete")}}
                  </v-list-item>
                  <!--
                  <v-list-item
                    v-if="item.state === 6"
                    :disabled="!item.inherited"
                    @click="setActiveProduct(item, false)"
                  >
                    <v-icon class="mr-4">mdi-pause</v-icon>
                    {{ capitalizeString("condAdmin.actions.disable")}}
                  </v-list-item>
                  <v-list-item
                    v-else
                    @click="setActiveProduct(item, true)"
                    :disabled="!item.inherited"
                  >
                    <v-icon class="mr-4">mdi-play</v-icon>
                    {{ capitalizeString("condAdmin.actions.enable")}}
                  </v-list-item>
                  -->
                </v-list>
              </v-menu>
<!--
              <v-chip
                v-if="item.inherited === true"
                v-tooltip="$tooltip($t('condAdmin.rvModification.inherited'))"
              >
                <v-icon>mdi-link-lock</v-icon>
              </v-chip>-->
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>

    <JsonExporter
      objectType="rvModifications"
      module="condAdmin"
      ref="jsonExporter"
    />
    <DoubletDlg
      ref="doubletDlg"
      :fields="doubletFields"
      :hint="this.$t('condAdmin.productTypeList.importDoublet')"
    />
  </v-card>
</template>

<script lang="js">
import { refreshRVModificationList, refreshProductList, refreshDriveTypeList, refreshProductTypeList, updateRVModificationState } from '../js/condAdminHelper.js';
import { isProcessStateOK, newMessage } from '@/base/js/ProcessDataHelper';
import { complexFilter } from '@/base/js/ObjectHelper';
import condAdminMixin from '../js/condAdminMixin.js';
import SearchField from '@/common/SearchField';
import SearchSelect from '@/common/SearchSelect';
import JsonImporter from '@/common/JsonImporter';
import JsonExporter from '@/common/JsonExporter';
import DoubletDlg from '@/common/DoubletDlg';
import EditField from '@/common/EditField';
import QuickFilter from '@/common/QuickFilter';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'RVModificationTable',
  components: {
    SearchField,
    SearchSelect,
    JsonImporter,
    JsonExporter,
    EditField,
    DoubletDlg,
    QuickFilter

  },
  mixins: [ condAdminMixin ],
  data () {
    return {
      rvModificationList: [],
      editedItem: null,
      selected: [],
      listSortKey: 'name',
      max45chars: v => v.length <= 45 || 'maximal 45 Zeichen',
      footerProps: {
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageOptions: [5, 15, 30, 50, -1],
        itemsPerPage: 15
      },
      filteredList: [],
      showInherited: null,
      availableColumns: [
        { text: this.$t('condAdmin.product.productType'), active: true, value: 'productTypeUid', formatter: this.formatValue },
        { text: this.$t('condAdmin.product.subProductType'), active: true, value: 'subProductTypeUid', formatter: this.formatValue },
        { text: this.$t('condAdmin.product.brand'), active: true, value: 'brand', formatter: this.formatValue },
        { text: this.$t('condAdmin.product.productName'), active: true, value: 'productName', formatter: this.formatValue },
        { text: this.$t('condAdmin.product.driveType'), active: true, value: 'driveTypeUid', formatter: this.formatValue },
        { text: this.$t('condAdmin.rvModification.rvModiValue'), active: true, value: 'rvModiValue', formatter: this.formatValue },
        { text: this.$t('base.state'), active: true, value: 'state' }
      ],
      filter: {
        productTypeUid: { condition: 'is', value: null, type: 'SelectBox', items: 'productTypeList', itemText: 'name', itemValue: 'uid' },
        subProductTypeUid: { condition: 'like', value: null, type: 'SelectBox', items: 'subProductTypeList', itemText: 'name', itemValue: 'uid' },
        brand: { condition: 'like', value: null, type: 'SelectBox', items: 'brandList', itemText: 'name', itemValue: 'name' },
        productName: { condition: 'like', value: null, type: 'SearchField' },
        driveTypeUid: { condition: 'is', value: null, type: 'SelectBox', items: 'driveTypeList', itemText: 'name', itemValue: 'uid' }
      },
      doubletFields: [
        { key: 'productTypeName', text: this.$t('condAdmin.product.productType'), unique: true, readonly: true },
        { key: 'subProductTypeName', text: this.$t('condAdmin.product.subProductType'), unique: true, readonly: true },
        { key: 'brand', text: this.$t('condAdmin.product.brand'), unique: true, readonly: true },
        { key: 'productName', text: this.$t('condAdmin.product.productName'), unique: true, readonly: true },
        { key: 'driveTypeName', text: this.$t('condAdmin.product.driveType'), unique: true, readonly: true },
        { key: 'rvModiValue', text: this.$t('condAdmin.product.driveType'), unique: true, readonly: true }
      ]
    };
  },
  computed: {
    listHeaders () {
      let h = [];
      for (let mc of this.availableColumns) {
        if (mc.active === true) {
          h.push(mc);
        }
      }
      h.push({ text: 'menu', value: 'menu', sortable: false });
      return h;
    },
    brandList () {
      let list = [];
      for (let e of this.$store.state.condAdmin.productList) {
        if (e.brand !== null) {
          let brands = e.brand.split(',');
          for (let b of brands) {
            if (!list.includes(b.trim())) list.push(b.trim());
          }
        }
        if (e.brand == null && !list.includes(this.NULLVALUE)) list.push(this.NULLVALUE);
      }
      return list.sort((a, b) => a > b);
    },
    modelList () {
      let list = [];
      if (this.filter['brand'].value === null) {
        list.push(this.NULLVALUE);
      } else {
        let modelList = this.$store.state.condAdmin.productList.filter(item => item.brand === this.filter['brand'].value);
        if (modelList !== null) {
          for (let e of modelList) {
            if (e.productName !== null) {
              if (!list.includes(e.productName.trim())) {
                list.push(e.productName.trim());
              }
            }
          }
        } else {
          list.push(this.NULLVALUE);
        }
      }
      return list.sort((a, b) => a > b);
    },

    subProductTypeList () {
      let list = [];
      if (this.filter['productTypeUid'].value === null) {
        list.push({ uid: null, name: this.NULLVALUE });
      } else {
        let productType = this.$store.state.condAdmin.productTypeList.find(item => item.uid === this.filter['productTypeUid'].value);

        if (productType !== null) {
          for (let e of productType.subProductTypes) {
            if (!list.includes(e.name.trim())) {
              list.push({ uid: e.uid, name: e.name.trim() });
            }
          }
        } else {
          list.push(this.NULLVALUE);
        }
      }
      return list.sort((a, b) => a > b);
    },
    hasInheritedRVModifications () {
      if (this.$store.state.condAdmin.rvModificationList !== null) {
        return (this.$store.state.condAdmin.rvModificationList.filter((c) => c.inherited === true).length > 0);
      } else {
        return false;
      }
    },
    inheritedCount () {
      return this.filteredList.filter((e) => e.inherited === true).length;
    }
  },
  async mounted () {
    this.getUserTableSettings('rvModificationTable');
    if (this.$store.state.condAdmin.productList == null || this.$store.state.condAdmin.productList.length === 0) {
      await refreshProductList();
    }
    if (this.$store.state.condAdmin.rvModificationList === null) {
      await refreshRVModificationList();
    }
    if (this.$store.state.condAdmin.driveTypeList === null) {
      await refreshDriveTypeList();
    }
    if (this.$store.state.condAdmin.productTypeList === null) {
      await refreshProductTypeList();
    }
    this.filteredList = complexFilter(this.$store.state.condAdmin.rvModificationList, this.filter);
  },
  methods: {
    async checkLeave () {
      return true;
    },
    productSelectLists (value) {
      switch (value) {
        case 'productTypeList':
          return this.$store.state.condAdmin.productTypeList;
        case 'brandList':
          return this.brandList;
        case 'subProductTypeList':
          return this.subProductTypeList;
        case 'modelList':
          return this.modelList;
        case 'driveTypeList':
          return this.$store.state.condAdmin.driveTypeList;
      }
    },

    getSubProductTypeList (productTypeUid) {
      let list = [];

      if (productTypeUid === null || productTypeUid.length === 0) {
        // let list = [{ id: null, name: null }];
        list.push({ uid: null, name: this.NULLVALUE });

        return list;
      } else {
        let pt = this.$store.state.condAdmin.productTypeList.find((p) => p.uid === productTypeUid);
        return list.concat(pt.subProductTypes);
      }
    },
    getModelList (brand) {
      let list = [];
      if (brand === null) {
        list.push(this.NULLVALUE);
      } else {
        let modelList = this.$store.state.condAdmin.productList.filter(item => item.brand === brand);
        if (modelList !== null) {
          for (let e of modelList) {
            if (e.productName !== null) {
              if (!list.includes(e.productName.trim())) {
                list.push(e.productName.trim());
              }
            }
          }
        } else {
          list.push(this.NULLVALUE);
        }
      }
      return list.sort((a, b) => a > b);
    },
    isDisabled (value) {
      let disabled = false;
      if (value === 'subProductTypeList') {
        if (this.filter['productType'].value === null) {
          disabled = true;
        }
        return disabled;
      }
    },
    setProductType (item, uid) {
      if (item.productTypeUid !== uid) {
        item.productTypeUid = uid;
        item.subProductTypeUid = null;
        // this.setDirty();
      }
      // this.productAssignmentChange();
    },
    setSubProductType (item, uid) {
      if (item.subProductTypeUid !== uid) {
        item.subProductTypeUid = uid;
        // this.setDirty();
      }
      // this.productAssignmentChange();
    },
    setDriveType (item, uid) {
      if (item.driveTypeUid !== uid) {
        item.driveTypeUid = uid;
        // this.setDirty();
      }
      // this.productAssignmentChange();
    },
    setRVModiValue (item, value) {
      item.rvModiValue = value;
    },
    setProductName (item, value) {
      if (value !== null && value.length > 0) {
        item.productName = value;
      } else {
        item.productName = null;
      }
    },
    setActiveProduct (product, value) {
      let state = value === true ? 6 : 10;
      updateRVModificationState(product, state);
    },
    getRVModiValue (item) {
      return item.rvModiValue;
    },
    async getRVModificationList () {
      await refreshRVModificationList();
      this.filterRVModifications();
      // this.filteredList = complexFilter(this.$store.state.condAdmin.rvModificationList.filter((e) => e.state === 6 || e.state === 0), this.filter);
    },
    async deleteRVModifications () {
      if (await this.$globals.Confirm.yesNoDlg(this.$t('condAdmin.rvModificationList.deleteRVModification'), this.$t('condAdmin.rvModificationList.deleteRVModificationConfirmText'))) {
        for (let rvModi of this.selected) {
          this.callDeleteRVModificationService(rvModi);
        }
      }
    },
    async deleteRVModification (rvModi) {
      // show confirmation dialog
      if (await this.$globals.Confirm.yesNoDlg(this.$t('condAdmin.rvModificationList.deleteRVModification'), this.$t('condAdmin.rvModificationList.deleteRVModificationConfirmText'))) {
        this.callDeleteRVModificationService(rvModi);
      }
    },
    async callDeleteRVModificationService (rvModi) {
      let ioData = {
        clientKey: this.$store.state.condAdmin.clientKey,
        rvModification: {
          uid: rvModi.uid,
          rvmUid: rvModi.rvmUid
        }
      };
      this.$restClient.callProcess('condAdmin', 'deleteRVModification', ioData).then(
        (processData) => {
          if (isProcessStateOK(processData)) {
            this.$globals.Info.open([{ type: 'success', message: this.$t('condAdmin.rvModificationList.deleted', { rvModi: rvModi.name }) }]);
          } else {
            this.$globals.Info.open(processData.processState.messages);
          }
          this.$store.state.condAdmin.rvModificationList.splice(this.$store.state.condAdmin.rvModificationList.findIndex((p) => p.uid === rvModi.uid), 1);
          this.filteredList = complexFilter(this.$store.state.condAdmin.rvModificationList.filter((e) => e.state === 6 || e.state === 0), this.filter);
        }
      );
      await this.getRVModificationList();
    },
    async createRVModification () {
      this.editedItem = { uid: null, productTypeUid: '', subProductTypeUid: '', brand: '', productName: '', driveTypeUid: '', rvmUid: uuidv4(), state: 6, rvModiValue: null };
      this.filteredList.push(this.editedItem);
      this.$nextTick(() => {
        this.editRVModification(this.editedItem);
      });
    },
    editRVModification (rvModi = null) {
      if (rvModi == null) {
        rvModi = this.selected[0].uid;
      }
      this.editedItem = JSON.parse(JSON.stringify(rvModi));
      this.$refs['RVModificationDlg_' + rvModi.rvmUid].isActive = true;
    },
    async cancelRVModification () {
      this.editedItem = null;
      await this.getRVModificationList();
    },
    async save (rvModi) {
      let existing = await this.importUniqueCheck(rvModi, 'save (rvModi)');
      if (existing != null) {
        await this.showDoublettenDialog(existing, rvModi);
        await this.getRVModificationList();
      } else {
        await this.saveRVModification(rvModi);
      }
    },
    async saveRVModification (rvModi) {
      let processName = 'updateRVModification';
      let ioData = {
        clientKey: this.$store.state.condAdmin.clientKey,
        rvModification: {
          rvmUid: rvModi.rvmUid,
          productTypeUid: rvModi.productTypeUid,
          subProductTypeUid: rvModi.subProductTypeUid,
          brand: rvModi.brand,
          productName: rvModi.productName,
          driveTypeUid: rvModi.driveTypeUid,
          rvModiValue: rvModi.rvModiValue
        }
      };

      if (rvModi.uid == null) {
        processName = 'createRVModification';
      } else {
        ioData.rvModification.uid = rvModi.uid;
      }

      await this.$restClient.callProcess('condAdmin', processName, ioData).then(
        (processData) => {
          if (isProcessStateOK(processData)) {
            if (rvModi.uid != null) {
              this.$store.state.condAdmin.rvModificationList.splice(
                this.$store.state.condAdmin.rvModificationList.findIndex((p) => p.uid === rvModi.uid), 1
              );
            }
            this.$store.state.condAdmin.rvModificationList.push(processData.ioData.rvModification);
            this.filteredList = complexFilter(this.$store.state.condAdmin.rvModificationList.filter((e) => e.state === 6 || e.state === 0), this.filter);
            this.editedItem = null;
            this.$globals.Info.open([{ type: 'success', message: this.$t('condAdmin.rvModificationList.saved') }]);
          } else {
            this.$globals.Info.open(processData.processState.messages);
          }
        }
      );
      await this.getRVModificationList();
    },

    clickedRow (rvModification) {
      if (this.hasUserRight('manageBaseData') === true && this.getOrgSetting('createOwnData') === true && rvModification.inherited !== true) {
        this.editRVModification(rvModification);
      }
    },
    getItemPerPage (val) {
      this.footerProps.itemsPerPage = val;
      this.$store.state.condAdmin.userSettings['rvModificationTable'].footerPropItemsPerPage = val;
    },
    setAvailableHeaders (column, value) {
      this.$store.state.condAdmin.userSettings['rvModificationTable'].columns[column.value] = value;
    },
    applyFilters (value, filtername) {
      this.filter[filtername].value = value;
      this.filteredList = complexFilter(this.$store.state.condAdmin.rvModificationList, this.filter);
      this.$store.state.condAdmin.userSettings['rvModificationTable'].filter[filtername] = value;
    },
    filterRVModifications () {
      let list = this.$store.state.condAdmin.rvModificationList;
      if (this.showInherited === true) {
        list = list.filter((e) => e.inherited === true);
      } else if (this.showInherited === false) {
        list = list.filter((e) => e.inherited !== true);
      }
      this.filteredList = complexFilter(list, this.filter);
    },
    applyInheritedFilter (value) {
      this.showInherited = value;
      this.filterRVModifications();
    },
    exportData () {
      let rvModifications = JSON.parse(JSON.stringify(this.selected));
      this.$refs.jsonExporter.exportJsonData({ rvModifications });
    },
    async importData (json) {
      await refreshRVModificationList();
      let imported = 0;
      let total = json.data.rvModifications.length;

      for (let imp of json.data.rvModifications) {
        if (imp.inherited !== true) {
        // check already existing dealerKey
          let existing = await this.importUniqueCheck(imp);
          if (existing != null) {
            imported += await this.showDoublettenDialog(existing, imp);
          } else {
            imp.uid = null;// zurücksetzen neue Uid wird in lambda bei Create vergeben
            imp.rvmUid = null; // zurücksetzen damit neue rmvUid in lambda bei Create vergeben wird
            await this.saveRVModification(imp);
            // console.log('imported', JSON.stringify(imp));
            imported++;
          }
        }
      }
      this.$globals.Info.open([ newMessage('success', this.$t('condAdmin.importResult', { imported, total })) ]);
      if (imported > 0) refreshRVModificationList();
    },
    async showDoublettenDialog (existing, imp) {
      let imported = 0;

      // build temporay calcTypeElements to be displayed in doubletDlg
      let impTmp = this.createDoubletObject(imp);
      let exTmp = this.createDoubletObject(existing);

      let action = await this.$refs.doubletDlg.showSimple(exTmp, impTmp);
      switch (action) {
        case 'overwrite':
          if (existing.inherited) {
            this.$globals.Info.open([ newMessage('userError', this.$t('condAdmin.rvModificationList.overwriteError')) ]);
          } else {
            imp.uid = existing.uid;
            await this.saveRVModification(imp);
          }
          // console.log('imported', JSON.stringify(merged));
          imported++;
          break;
          /*
            case 'copy':
              delete merged.stList;
              await this.saveRVModification(merged);
              // console.log('imported', JSON.stringify(merged));
              imported++;
              break; */
        case 'skipNew':
        default:
          break;
      }
      return imported;
    },
    createDoubletObject (rvm) {
      let o = {
        productTypeName: '',
        subProductTypeName: '',
        brand: rvm.brand,
        productName: rvm.productName,
        driveTypeName: '',
        rvModiValue: null
      };
      if (rvm.productTypeUid != null && rvm.productTypeUid.length > 0) {
        let pt = this.$store.state.condAdmin.productTypeList.find(pt => pt.uid === rvm.productTypeUid);
        o.productTypeName = pt.name;

        if (pt.subProductTypes.length > 0 && rvm.subProductTypeUid !== null && rvm.subProductTypeUid.length > 0) {
          o.subProductTypeName = pt.subProductTypes.find(spt => spt.uid === rvm.subProductTypeUid).name;
        }
      }
      if (rvm.driveTypeUid != null && rvm.driveTypeUid.length > 0) {
        o.driveTypeName = this.$store.state.condAdmin.driveTypeList.find(dt => dt.uid === rvm.driveTypeUid).name;
      }
      o.rvModiValue = rvm.rvModiValue;

      return o;
    },

    preImportCheckFunction (json) {
      if (json.data.rvModifications == null || json.data.rvModifications.length < 1) {
        this.$globals.Info.open([ newMessage('userError', this.$t('condAdmin.rvModificationList.noImportData')) ]);
        return false;
      }
      return true;
    },
    async importUniqueCheck (merged) {
      console.debug('merged', JSON.stringify(merged));
      let existing = this.$store.state.condAdmin.rvModificationList.find((i) => i.productTypeUid === merged.productTypeUid &&
                                                                                i.subProductTypeUid === merged.subProductTypeUid &&
                                                                                i.brand === merged.brand &&
                                                                                i.productName === merged.productName &&
                                                                                i.driveTypeUid === merged.driveTypeUid &&
                                                                                i.uid !== merged.uid && i.inherited !== true);
      console.debug('exisiting', JSON.stringify(existing));
      return existing;
    }
  }
};
</script>

<style scoped>

</style>
